import React from "react";
import { useNavigate } from "react-router-dom";
import { useApp } from "../context/AppContext";
import { Eye, MapPin, Ruler, Footprints } from "lucide-react";

const PlayerCard = ({ player }) => {
  const { t } = useApp();
  const navigate = useNavigate();

  return (
    <div
      onClick={() => navigate(`/player/${player.id}`)}
      className="card-hover cursor-pointer bg-[#0f1116] border border-white/8 rounded-2xl overflow-hidden"
    >
      <div className="relative h-32 bg-gradient-to-br from-[#161b26] to-[#0f1116] flex items-center justify-center">
        <div className="w-20 h-20 rounded-full bg-gradient-to-br from-blue-500/90 to-blue-700 flex items-center justify-center text-3xl font-bold text-white font-display shadow-lg shadow-blue-500/20">
          {player.initial}
        </div>
        {player.openForTrial && (
          <span className="absolute top-3 right-3 text-[10px] font-semibold uppercase tracking-wide bg-emerald-500/15 text-emerald-400 border border-emerald-500/30 px-2 py-1 rounded-full">
            {t.player.openTrial}
          </span>
        )}
        <span className="absolute top-3 left-3 text-[11px] text-gray-300 bg-black/40 backdrop-blur px-2 py-1 rounded-md">
          {player.position}
        </span>
      </div>

      <div className="p-4">
        <div className="flex items-center justify-between">
          <h3 className="font-semibold text-white text-[15px]">{player.name}</h3>
          <span className="text-xs text-gray-500 flex items-center gap-1">
            <Eye className="w-3.5 h-3.5" /> {player.views}
          </span>
        </div>
        <p className="text-xs text-gray-500 mt-0.5">
          {player.age} {t.player.years} ({player.birthYear})
        </p>

        <div className="mt-3 space-y-1.5 text-xs text-gray-400">
          <div className="flex items-center gap-2">
            <MapPin className="w-3.5 h-3.5 text-gray-600" /> {player.city}, {player.country}
          </div>
          <div className="flex items-center gap-2">
            <Ruler className="w-3.5 h-3.5 text-gray-600" /> {player.height}cm
            <span className="mx-1 text-gray-700">·</span>
            <Footprints className="w-3.5 h-3.5 text-gray-600" /> {player.foot} foot
          </div>
        </div>

        <div className="mt-3 pt-3 border-t border-white/5">
          <span className="text-xs font-medium text-blue-400">{player.club}</span>
        </div>
      </div>
    </div>
  );
};

export default PlayerCard;
